import { useChatStore } from "@/stores/useChatStore";

/** 履歴のカードの開閉状態。ユーザーが一度も操作していなければ undefined。 */
export function useDisclosureOpen(key: string): [boolean | undefined, (open: boolean) => void] {
	const open = useChatStore((s) => s.disclosureOpen[key]);
	const setDisclosureOpen = useChatStore((s) => s.setDisclosureOpen);
	return [open, (next) => setDisclosureOpen(key, next)];
}
